var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card-form container",
    attrs: {
      "id": "print"
    }
  }, [_c('div', {
    staticClass: "mb-5 w-100 d-flex justify-content-between"
  }, [_c('div', [_c('img', {
    staticClass: "max-h-40px",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.secundary')
    }
  })]), _c('div', {
    staticClass: "mt-4"
  }, [_c('span', [_vm._v("Impressão - "), _c('label', [_vm._v(_vm._s(_vm.title))])]), _c('br')])]), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    staticClass: "mb-2 border border-primary",
    attrs: {
      "title": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm.data.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "responsive": "sm",
      "fields": _vm.cleanLabels,
      "items": _vm.tableItems
    },
    scopedSlots: _vm._u([{
      key: "cell(descricao)",
      fn: function fn(data) {
        return [data.item.isSaldoAnterior ? _c('div') : _c('div', [_c('div', [_vm._v(_vm._s(data.item.descricao))]), _vm.getHistorico(data.item) ? _c('div', {
          staticClass: "text-muted small mt-1"
        }, [_vm._v(" " + _vm._s(_vm.getHistorico(data.item)) + " ")]) : _vm._e()])];
      }
    }, {
      key: "cell(valor_movimento)",
      fn: function fn(data) {
        return [data.item.isSaldoAnterior ? _c('div', {
          staticClass: "font-weight-bold text-right"
        }, [_vm._v(" Saldo em " + _vm._s(_vm.formatDate(data.item.data_saldo_dia_anterior)) + " — " + _vm._s(_vm.numberToReal(data.item.valor_movimento)) + " ")]) : _c('div', {
          staticClass: "text-right"
        }, [_c('span', {
          style: {
            color: data.item.tipo_movimento === 1 ? 'green' : 'red'
          }
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(data.item.valor_movimento)) + " ")])])];
      }
    }, {
      key: "cell(data_movimento)",
      fn: function fn(data) {
        return [data.item.isSaldoAnterior ? _c('div') : _c('div', [_vm._v(" " + _vm._s(_vm.formatDate(data.item.data_movimento)) + " ")])];
      }
    }], null, false, 622574186)
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-end"
  }, [_c('img', {
    staticClass: "max-h-30px mr-5",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.icone')
    }
  })])]), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-center d-print-none"
  }, [_c('button', {
    staticClass: "btn btn-success btn-hover-primary mr-2",
    on: {
      "click": _vm.printDocument
    }
  }, [_vm._v(" Imprimir ")]), _c('button', {
    staticClass: "btn btn-success btn-hover-primary mr-2",
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v(" Voltar ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };